// extracted by mini-css-extract-plugin
module.exports = {"solid":"CommonLink_solid__zft_P","outline":"CommonLink_outline__XuzRA","medium":"CommonLink_medium__N9Lpj","big":"CommonLink_big__09_jX"};